import { render, staticRenderFns } from "./rightcard1.vue?vue&type=template&id=0b90030e&scoped=true"
import script from "./rightcard1.vue?vue&type=script&lang=js"
export * from "./rightcard1.vue?vue&type=script&lang=js"
import style0 from "./rightcard1.vue?vue&type=style&index=0&id=0b90030e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90030e",
  null
  
)

export default component.exports